import { EMAIL_VERIFICATION_COPY, VERIFICATION_CODE_INPUT_ID } from '../../consts';
import { formatResendCountdown } from '../../utils';
import { profileEmailSectionStyles } from './profile-email-section.styles';

type ProfileEmailCodeFormProps = {
  destination: string;
  codeValue: string;
  codeError: string;
  secondsLeft: number;
  isSubmitting: boolean;
  onCodeChange: (value: string) => void;
  onConfirm: () => void;
  onResend: () => void;
  onChangeEmail: () => void;
};

const getResendLabel = (secondsLeft: number) =>
  secondsLeft > 0
    ? `${EMAIL_VERIFICATION_COPY.resendWait} ${formatResendCountdown(secondsLeft)}`
    : EMAIL_VERIFICATION_COPY.resendReady;

export const ProfileEmailCodeForm = ({
  destination,
  codeValue,
  codeError,
  secondsLeft,
  isSubmitting,
  onCodeChange,
  onConfirm,
  onResend,
  onChangeEmail,
}: ProfileEmailCodeFormProps) => (
  <form
    className={profileEmailSectionStyles.formPanel}
    onSubmit={(event) => {
      event.preventDefault();
      onConfirm();
    }}
    noValidate
  >
    <label htmlFor={VERIFICATION_CODE_INPUT_ID} className={profileEmailSectionStyles.fieldLabel}>
      {EMAIL_VERIFICATION_COPY.codeSentLabel} {destination}
    </label>
    <div className="flex flex-col gap-2.5 sm:flex-row">
      <input
        id={VERIFICATION_CODE_INPUT_ID}
        name="verification-code"
        value={codeValue}
        onChange={(event) => onCodeChange(event.target.value)}
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={6}
        spellCheck={false}
        aria-invalid={Boolean(codeError)}
        aria-describedby={codeError ? 'code-error' : undefined}
        className={profileEmailSectionStyles.codeInput}
      />
      <button type="submit" disabled={isSubmitting} className={profileEmailSectionStyles.primary}>
        {EMAIL_VERIFICATION_COPY.confirmCode}
      </button>
    </div>
    {codeError ? (
      <p id="code-error" className={profileEmailSectionStyles.error} role="alert">
        {codeError}
      </p>
    ) : null}
    <div className="flex flex-col items-start gap-2 sm:flex-row sm:items-center sm:justify-between">
      <button
        type="button"
        onClick={onResend}
        disabled={isSubmitting || secondsLeft > 0}
        className={profileEmailSectionStyles.link}
      >
        {getResendLabel(secondsLeft)}
      </button>
      <button type="button" onClick={onChangeEmail} className={profileEmailSectionStyles.link}>
        {EMAIL_VERIFICATION_COPY.editEmail}
      </button>
    </div>
  </form>
);
